// Label.js
import React from 'react';
import './userStyle.css';

const Label = ({ label, value }) => {
  return (
    <div className="mb-2">
      <label className="form-label bold-label">{label} :</label>
      <label className="form-label">{value}</label>
    </div>
  );
};

export default Label;
